<template>
  <div>
    <el-card>
      <div class="group-title">
        <span style="font-size: 14px; color: #606266"
          >Bill No：{{ formData.fabricStockInNo }}</span
        >
        <el-divider direction="vertical"></el-divider>
        <span>Status：{{ formData.fabricStockInStatusName }}</span>
        <br />
        <span style="font-size: 14px; color: #606266">
          Create：{{ formData.createByName }} at
          {{ formData.createDate }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Modify：{{ formData.modifyByName }} at
          {{ formData.modifyDate }}
        </span>
        <el-divider
          v-if="formData.auditByName"
          direction="vertical"
        ></el-divider>
        <span
          style="font-size: 14px; color: #606266"
          v-if="formData.auditByName"
        >
          AuditBy：{{ formData.auditByName }} at
          {{ formData.auditDate }}
        </span>
      </div>
      <el-form ref="formData" :model="formData" :rules="rules" size="mini">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item :label="$l('form_label_storage_date') || '入库日期'">
              <el-date-picker
                :disabled="disabled"
                clearable
                v-model="formData.inStockDate"
                type="date"
                value-format="yyyy-MM-dd"
                size="mini"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                style="width:100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item
              :label="$l('form_label_unitPrice') || '单价'"
              prop="unitPrice"
            >
              <el-input
                disabled
                v-model="formData.unitPrice"
                maxlength="12"
                clearable
                size="mini"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item
              :label="$l('form_label_fabric_unit') || '面料单位'"
              prop="fabricUnit"
            >
              <dict-select
                v-model="formData.fabricUnit"
                url="/digitalCenter/common/dict/biz"
                :body="{ dictType: 'fabricYarnUnit' }"
                disabled
                size="mini"
                filterable
                clearable
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item
              :label="$l('form_label_request_quantity') || '需求总数量'"
              prop="requestQuantity"
            >
              <el-input
                disabled
                v-model="formData.requestQuantity"
                maxlength="8"
                clearable
                size="mini"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item
              :label="$l('form_label_inStock_quantity') || '入库总数量'"
              prop="inStockQuantity"
            >
              <el-input
                disabled
                v-model="formData.inStockQuantity"
                maxlength="8"
                clearable
                size="mini"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_storage_amount') || '入库金额'"
              prop="inStockAmount"
            >
              <el-input
                disabled
                v-model="formData.inStockAmount"
                maxlength="11"
                clearable
                size="mini"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$l('form_label_memo') || '备注说明'">
              <el-input
                :disabled="disabled"
                v-model="formData.inStockMemo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                maxlength="500"
                clearable
                size="mini"
                :autosize="{ minRows: 3, maxRows: 3 }"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <div class="side-frame-success group-title">
            <span style="font-size: 14px; color: #606266"
              >{{ $l('form_label_fabricRequestNo') || '申请单号' }}：{{
                formData.fabricRequestNo || '--'
              }}</span
            ><el-divider direction="vertical"></el-divider>
            <span style="font-size: 14px; color: #606266"
              >{{ $l('form_label_fabricAgentName') || '业务员' }}：{{ formData.fabricAgentName || '--' }}</span
            >
            <el-divider direction="vertical"></el-divider>
            <span style="font-size: 14px; color: #606266"
              >{{ $l('form_label_requestDate') || '开发依赖日期' }}：{{ formData.requestDate || '--' }}</span
            >
            <el-divider direction="vertical"></el-divider>
            <span style="font-size: 14px; color: #606266"
              >{{ $l('INDEX.label_customer') || '客户' }}：{{
                formData.custName || '--'
              }}</span
            >
          </div>
          <div>
            <span style="font-size: 14px; color: #606266"
              >{{ $l('form_label_scmName') || '供应商' }}：{{ formData.scmName || '--' }}</span
            >
            <el-divider direction="vertical"></el-divider>
            <span style="font-size: 14px; color: #606266"
              >{{ $l('form_label_contactName') || '工厂联系人' }}：{{ formData.contactName || '--' }}</span
            >
            <el-divider direction="vertical"></el-divider>
            <span style="font-size: 14px; color: #606266"
              >{{ $l('form_label_contactMobile') || '联系人手机' }}：{{ formData.contactMobile || '--' }}</span
            >
            <el-divider direction="vertical"></el-divider>
            <span style="font-size: 14px; color: #606266"
              >{{ $l('form_label_factoryNumber') || '工厂面料编号' }}：{{ formData.factoryNumber || '--' }}</span
            >
          </div>
          <div>
            <span style="font-size: 14px; color: #606266"
              >{{ $l('form_label_fabricNo') || '面料编号' }}：{{ formData.fabricNo || '--' }}</span
            ><el-divider direction="vertical"></el-divider>
            <span style="font-size: 14px; color: #606266"
              >{{ $l('form_label_fabricName') || '面料名称' }}：{{ formData.fabricName || '--' }}</span
            >
            <el-divider direction="vertical"></el-divider>
            <span style="font-size: 14px; color: #606266">{{
              formData.fabricNameEn
            }}</span>
          </div>
          <div>
            <span style="font-size: 14px; color: #606266"
              >{{ $l('form_label_fabricContent') || '面料成分' }}：{{ formData.fabricContent || '--' }}</span
            >
            <el-divider direction="vertical"></el-divider>
            <span style="font-size: 14px; color: #606266"
              >{{ $l('form_label_wid') || '面料门幅' }}：{{ formData.wid || '--' }}
              {{ formData.widUnit || '--' }}</span
            >
            <el-divider direction="vertical"></el-divider>
            <span style="font-size: 14px; color: #606266"
              >{{ $l('form_label_fabricWeight') || '面料克重' }}：{{ formData.fabricWeight || '--' }}
              {{ formData.fabricWeightUnit || '--' }}
            </span>
            <el-divider direction="vertical"></el-divider>
            <span style="font-size: 14px; color: #606266"
              >{{ $l('form_label_density') || '密度' }}：{{ formData.density || '--' }}</span
            >
            <el-divider direction="vertical"></el-divider>
            <span style="font-size: 14px; color: #606266"
              >{{ $l('form_label_yarnCount') || '纱织' }}：{{ formData.yarnCount || '--' }}</span
            >
          </div>
          <div>
            <span style="font-size: 14px; color: #606266"
              >{{ $l('form_label_fabricUse') || '面料用途' }}：{{ formData.fabricUse || '--' }}</span
            >
          </div>
        </el-row>
        <el-row>
          <colors
            ref="colors"
            :main-type="type"
            :disabled="disabled"
            :params="params"
          />
        </el-row>
        <el-row class="d2-mt">
          <el-col :span="20">
            <el-button
              @click="save"
              v-if="!disabled"
              size="mini"
              type="primary"
              >{{ $l('INDEX.btn_save') || '保存' }}</el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </el-card>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import colors from './fabricColor/list'
import { mapActions } from 'vuex'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  components: {
    colors,
  },
  data() {
    return {
      inStockQuantityDisabled: false, // 入库总数量是否可用
      params: {
        fabricStockInCode: '',
        type: '',
      },
      functionOptions: [], //功能
      constructionOptions: [], //材料备注
      fabricDescriptionOptions: [], //面料名称
      patternOptions: [], //花型
      techniqueOptions: [], //工艺
      fabricYarnUnitOptions: [], //面料单位
      widUnitOptions: [], //门幅单位
      fabricWeightUnitOptions: [], // 面料克重单位
      ChooseMasterAttributeDictionaryVisible: false,
      pageHeader: '',
      dialogVisible: false,
      disabled: false,
      formData: {
        fabricStockInCode: '',
        fabricStockInNo: '',
        fabricStockInType: '',
        fabricRequestCode: '',
        fabricRequestNo: '',
        supCode: '',
        custName: '',
        contactName: '',
        contactMobile: '',
        fabricUse: '',
        requestDate: '',
        inStockDate: '',
        fabricAgentCode: '',
        fabricAgentName: '',
        fabricAgentDeptCode: '',
        fabricAgentDeptName: '',
        fabricCode: '',
        fabricNo: '',
        fabricName: '', //面料名称
        fabricNameEn: '', //面料名称en
        fabricAttributes: '',
        fabricContent: '',
        fabricContentEn: '',
        categoryCode: '',
        fabricCategoryCode: '',
        wid: '',
        widUnit: '',
        fabricWeight: '',
        fabricWeightUnit: '',
        density: '',
        yarnCount: '',
        fabricUnit: '',
        unitPrice: '',
        requestQuantity: '',
        inStockQuantity: '',
        inStockAmount: '',
        inStockMemo: '',
        isMulticolor: 'N',
        companyCode: '',
        fabricStockInStatus: '',
        createByName: '',
        createDate: '',
        modifyByName: '',
        modifyDate: '',
        auditByName: '',
        auditDate: '',
      },
      type: '',
      rules: {},
    }
  },
  mounted() {
    if (this.$route.params.fabricStockInCode) {
      let type = this.$route.params.pageType
      let fabricStockInCode = this.$route.params.fabricStockInCode
      this.init(type, fabricStockInCode)
    }
  },
  activated() {
    if (this.$route.params.fabricStockInCode) {
      let type = this.$route.params.pageType
      let fabricStockInCode = this.$route.params.fabricStockInCode
      this.init(type, fabricStockInCode)
    }
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    init(type, fabricStockInCode) {
      this.reset()
      if (type === 'edit') {
        this.type = type
        this.updateLoad(fabricStockInCode, type)
      } else if (type === 'detail') {
        this.type = type
        this.detailLoad(fabricStockInCode, type)
      }
    },
    updateLoad(fabricStockInCode, type) {
      this.pageHeader = this.$l('page_name_mofi') || '入库单修改'
      this.disabled = false
      let param = { fabricStockInCode: fabricStockInCode }
      this.loadData(param, type)
    },
    detailLoad(fabricStockInCode, type) {
      this.pageHeader = this.$l('page_name_fid') || '入库单详情'
      this.disabled = true
      let param = { fabricStockInCode: fabricStockInCode }
      this.loadData(param, type)
    },
    loadData(param, type) {
      this.$api.fabricStockInDetailApi(param).then((res) => {
        this.formData = res.body
        this.params.fabricStockInCode = res.body.fabricStockInCode
        this.params.type = type
        this.$refs.colors.load({
          fabricStockInCode: res.body.fabricStockInCode,
        })
      })
    },
    save() {
      const form = this.$refs.formData
      const listDetail = this.$refs.colors.getUpdateTableData()

      let saveParams = this.formData
      saveParams.listDetail = listDetail

      validate.formValidate([form], (valid) => {
        if (valid) {
          this.loadingOpen()
          this.$api
            .fabricStockInSaveApi(saveParams)
            .then(() => {
              this.loadingClose()
              this.saveOkQuestion()
            })
            .catch(() => {
              this.loadingClose()
            })
        }
      })
    },
    saveOkQuestion() {
      this.$alert(
        this.$l('INDEX.tips_save_ok') || '保存成功',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          confirmButtonText: '确定',
          callback: () => {
            this.closeCurPage()
          },
        }
      )
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },

    reset() {
      this.$refs.formData.resetFields()
      this.type = ''
      this.ChooseMasterAttributeDictionaryVisible = false
      this.dialogVisible = false
      this.formData = {
        fabricStockInCode: '',
        fabricStockInNo: '',
        fabricStockInType: '',
        fabricRequestCode: '',
        fabricRequestNo: '',
        supCode: '',
        custName: '',
        contactName: '',
        contactMobile: '',
        fabricUse: '',
        requestDate: '',
        inStockDate: '',
        fabricAgentCode: '',
        fabricAgentName: '',
        fabricAgentDeptCode: '',
        fabricAgentDeptName: '',
        fabricCode: '',
        fabricNo: '',
        fabricName: '',
        fabricNameEn: '',
        fabricAttributes: '',
        fabricContent: '',
        fabricContentEn: '',
        categoryCode: '',
        fabricCategoryCode: '',
        wid: '',
        widUnit: '',
        fabricWeight: '',
        fabricWeightUnit: '',
        density: '',
        yarnCount: '',
        fabricUnit: '',
        unitPrice: '',
        requestQuantity: '',
        inStockQuantity: '',
        inStockAmount: '',
        inStockMemo: '',
        isMulticolor: 'N',
        companyCode: '',
        fabricStockInStatus: '',
        createByName: '',
        createDate: '',
        modifyByName: '',
        modifyDate: '',
        auditByName: '',
        auditDate: '',
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
  margin: 15px 0;
}
.side-frame-success {
  padding: 1px 10px;
  border-left: 3px solid $color-success;
  margin: 15px 0;
}
.group-title {
  font-size: 14px;
  color: #606266;
}
</style>
